module.exports = __webpack_public_path__ + "img/dodo.72ed1fdf.png";